module.exports = __webpack_public_path__ + "static/new_guillermo-b6e95f731238a39c2c40b32de867172c.jpg";